<template>
  <div>
    <Teleport to="#top-menu-bar" defer>
      <PageTopBar>
        <template #item-name>
          <span>Import Ontology from Ontology Lookup Service (OLS)</span>
        </template>
      </PageTopBar>
    </Teleport>

    <div class="ols-import p-4">
      <div v-if="!ontologyId" class="notification is-warning has-text-centered">
        <span class="icon"><i class="fa fa-exclamation-triangle" /></span>
        <span>No ontology ID provided.</span>
        <router-link :to="{ name: 'olsBrowseOntologies' }" class="ml-2">
          Browse ontologies
        </router-link>
      </div>
      <OlsOntologyImportForm
        v-else
        :ontology-id="ontologyId"
        :preselect-category-id="forCategoryId"
        @imported="onImported"
      />
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { hasPrivilege } from '@/auth/authorization'
import { usePageShell } from '@/composables/usePageShell'
import { useStore } from '@/store'

import OlsOntologyImportForm from '@/components/OlsOntologyImportForm.vue'
import PageTopBar from '@/components/PageTopBar.vue'

export default {
  name: 'OlsOntologyImportFormView',
  components: { OlsOntologyImportForm, PageTopBar },
  setup() {
    usePageShell({
      title: 'Import Ontology from Ontology Lookup Service (OLS)',
    })
    const store = useStore()
    const route = useRoute()
    const router = useRouter()

    const ontologyId = ref('')
    const forCategoryId = ref('')
    const backTo = ref('')

    function onImported() {
      // When the user came from "add ontology source" on a record, return
      // them there instead of the generic ontologies list.
      if (backTo.value) {
        router.push(backTo.value)
        return
      }
      router.push({
        name: 'list',
        params: {
          appName: 'vocabularies',
          modelName: 'ontologies',
          modelType: 'default',
        },
      })
    }

    onMounted(() => {
      if (!hasPrivilege('vocabularies', 'ontology', 'add')) {
        store.commit('notify', {
          type: 'warning',
          message: 'You do not have permission to import ontologies.',
        })
        router.replace({ name: 'olsBrowseOntologies' })
        return
      }
      ontologyId.value = route.query.id || ''
      forCategoryId.value = route.query.for_category || ''
      backTo.value = route.query.back || ''
    })

    return { ontologyId, forCategoryId, onImported }
  },
}
</script>

<style lang="scss" scoped>
.ols-import {
  max-width: 860px;
}
</style>
